import { inject, Injectable } from '@angular/core';
import { AuthStateFacade } from '@zero/shared/util-global-state';
import { AuthorizationData, AuthPayloadTicket, Ticket, TicketData, TransactionAuthorizationResult } from '@zero/shared/util-models';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PortfolioReportFacade {
  public dueDate: string | Date;
  public dataToAuthorize: Observable<AuthorizationData<AuthPayloadTicket>>;
  public initiated = false;
  public succeeded = false;
  public errorMessage?: string;

  private readonly _authStateFacade = inject(AuthStateFacade);

  public requestReport() {
    if (!this.initiated) {
      this.initiated = true;
      this.dataToAuthorize = of(new AuthorizationData<AuthPayloadTicket>(new AuthPayloadTicket(this.createTicket())));
    }
  }

  public handleAuthenticationResult(result: TransactionAuthorizationResult) {
    this.succeeded = result.success;
    if (!result.success) {
      this.dataToAuthorize = null;
      if (result.reason === 'CanceledByUser') {
        this.initiated = false;
      } else {
        this.errorMessage = result.reason;
      }
    }
  }

  private createTicket(): Ticket {
    const ticket = new Ticket();
    ticket.customerId = this._authStateFacade.customerId;
    ticket.type = 'PORTFOLIO_REPORT';
    ticket.ticketData = new TicketData();
    ticket.ticketData.additionalProperties = {};
    ticket.ticketData.additionalProperties[TicketData.ATTR_NEW_PORTFOLIO_REPORT_DUE_DATE] = new Date(this.dueDate);

    return ticket;
  }
}
